import React, { useRef } from 'react';
import { FormatComponentProps } from './types';
import CodeMirrorEditor from '../../../codemirror/CodeMirrorEditor';

const FormulaBlock: React.FC<FormatComponentProps> = ({ content, formulaSelected }) => {
  const formulaMatch = content.match(/<FORMULA>([\s\S]*?)<\/FORMULA>/);
  const formula = formulaMatch ? formulaMatch[1] : '';

  // Create a ref to satisfy CodeMirrorEditor’s forwarded ref requirement
  const editorRef = useRef<HTMLDivElement>(null);

  return (
    <div className="formula-block">
      <button type="button" className="formula-block-header" onClick={() => formulaSelected?.(formula)}>
        Insert Formula
      </button>
      <div className="formula-block-content">
        <CodeMirrorEditor ref={editorRef} value={formula.trim()} readOnly={true} mode="goformz-formula" singleLine validateTokens={() => ({ errors: [] })} />
      </div>
    </div>
  );
};

export default FormulaBlock;
